import request from '@/utils/request'

let Courseware_industryApi = {

  /*课件行业列表*/
  list(data) {
    return request._post('/shop/plus.courseware_industry.Index/index', data);
},
/*添加课件行业*/
add(data) {
    return request._post('/shop/plus.courseware_industry.Index/add', data);
},
/*修改课件行业*/
edit(data) {
    return request._post('/shop/plus.courseware_industry.Index/edit', data);
},
/*删除课件行业*/
del(data) {
    return request._post('/shop/plus.courseware_industry.Index/del', data);
},
/*课件行业详情*/
detail(data) {
  return request._post('/shop/plus.courseware_industry.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.courseware_industry.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.courseware_industry.Setting/getSetting', data, errorback);
    },
}
export default Courseware_industryApi;



// WEBPACK FOOTER //
// ./src/api/courseware_industry.js